<template>
  <div
    class="flex flex-col"
    :class="!webviewStore.isActive && 'h-dvh'"
    :style="styles"
  >
    <WebviewNavbar v-if="webviewStore.isActive">Change your plan</WebviewNavbar>
    <BasicNavbar v-else />

    <div
      ref="container"
      class="min-h-0 flex-1 overflow-auto px-4 pb-[60px]"
      :class="!webviewStore.isActive && 'pt-[30px]'"
    >
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useUserStore } from '@/shared/stores/user'
import { UserPermission } from '@/shared/graphql/legacy/generated'
import { useRouter } from 'vue-router'
import { useWebviewStore } from '@/shared/stores/webview'
import { useDevice } from '@/shared/composables/useDevice'
import WebviewNavbar from '@/shared/components/WebviewNavbar.vue'
import BasicNavbar from '@/shared/components/BasicNavbar.vue'

const device = useDevice()
const router = useRouter()
const userStore = useUserStore()
const webviewStore = useWebviewStore()

const container = ref<HTMLElement>()

const user = computed(() => userStore.user)

watch(user, () => {
  if (!user.value?.permissions.includes(UserPermission.Pro)) {
    router.push('/home')
  }
})

const styles = computed(() => ({
  ...(webviewStore.isActive && {
    'margin-top': `${webviewStore.topSafeAreaHeight}px`,
    height: `${device.viewportHeight.value - webviewStore.topSafeAreaHeight}px`,
  }),
}))

onMounted(() => {
  if (!webviewStore.isActive) return
  container.value?.addEventListener('scroll', webviewStore.handleScroll)
})

onBeforeUnmount(() => {
  container.value?.removeEventListener('scroll', webviewStore.handleScroll)
})
</script>
